export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-w.7c3c3ef9.png";